export const CUSTOM_TOOLTIP_TEMPLATE = '<div class="custom-tooltip" style="border:{1}px solid {2};{3}">{4}</div>';
export const CUSTOM_TOOLTIP_TEMPLATE_WITH_ACCENT_COLOR = '<div class="custom-tooltip-with-accent-color{5}" style="border-left:7px solid {2};{3}">{4}</div>';
export const INVISIBLE_TOOLTIP = '<div style="display:none"></div>';
export const TOOLTIP_TEMPLATE = '<div class="chart-tooltip-block{8}" style="z-index:9999;{9}">' +
    '<span class="{1} chart-tooltip-key" style="{2}">{3}</span> ' +
    '<div style="{5}" class="chart-tooltip-color"></div> ' +
    '<span class="{4} chart-tooltip-value" style="{7}">{6}</span></div>';
export const formatterTemplates = {
    stackLabelForMultipleY: '<div style="padding:2px">{1}</div>',
};
export const CONFIGURED_TOOLTIP_TEMPLATE = '<span class="yAxisTitle"></span>{1}';
//# sourceMappingURL=highchart-formatter-templates.js.map